// extracted by mini-css-extract-plugin
module.exports = {"logoContainer":"fake_intercom-module--logoContainer--1va4V","logo":"fake_intercom-module--logo--lqrG6","intercomCard":"fake_intercom-module--intercomCard--3bfKr"};